import { EbUser } from "../classes/user";
import { AuthenticationService } from "../services/authentication.service";
import { Statique } from "../utils/statique";

export class SearchCriteria {
  public ebUserNum: number;
  public ebUserPassword: String;
  public email: string;
  public username: string;
  public ebEtablissementNum: number;
  public withListAdresse: boolean;
  public withListCostCenter: boolean;
  public withListContacts: boolean;
  public withAccessRights: boolean;
  public withPassword: boolean;
  public searchterm: string;
  public pageNumber: number;
  public size: number;
  public roleBroker: boolean;
  public roleTransporteur: boolean;
  public roleControlTower: boolean;
  public roleChargeur: boolean;
  public status: number;
  public demandeEnCours: boolean;
  public admin: Boolean;
  public ecRoleNum: number;
  public forInvite: boolean;
  public ebDestinationCountryNum: number;
  public ebCompagnieNum: number;
  public ebCompagnieGuestNum: number;
  public receivedRequest: boolean;
  public contactable: boolean;
  public contact: boolean;
  public blackList: boolean;
  public notBlackList: boolean;
  public sentRequests: boolean;
  public emailNomPrenom: string;
  public ebDemandeNum: number;
  public module: number;
  public ecCountryNum: number;
  public userService: number;
  public hsCode: string;
  public dateDeb: Date;
  public dateFin: Date;
  public etablissementRequest: boolean;
  public excludeConnectedUser: boolean;
  public relationWIthEtablissement: boolean;
  public user: string;
  public ebCommandeNum: number;
  public forChargeur: boolean;
  public forControlTower: boolean;
  public ignoreContact: boolean;

  listTransportRefPlugin: Array<any>;
  listCustomerReferencePlugin: Array<any>;
  listDestinationsPlugin: Array<any>;
  listOriginsPlugin: Array<any>;
  listCarrierPlugin: Array<any>;
  listStatutPlugin: Array<any>;
  listCostCenterPlugin: Array<any>;
  champListCategorie: Array<number>;
  listTransportRef: Array<number>;
  listCustomerReference: Array<number>;
  listDestinations: Array<number>;
  listOrigins: Array<number>;
  listCarrier: Array<number>;
  listStatut: Array<number>;
  listCostCenter: Array<number>;

  datePickUpFrom: String;
  datePickUpTo: String;
  datePickUpToPlugin: String;
  datePickUpFromPlugin: String;

  dateCreationFrom: String;
  dateCreationTo: String;
  dateCreationToPlugin: String;
  dateCreationFromPlugin: String;

  dateCommandeFrom: String;
  dateCommandeTo: String;

  dateCommandeFromPlugin: String;
  dateCommandeToPlugin: String;

  listCommandeNum: String;
  onlyAddressForEtablissement: boolean;

  mawb: String;
  numAwbBol: String;
  dateDepartFrom: String;
  dateDepartTo: String;
  export: number;

  ecMotifNum: number;

  superAdmin: Boolean;
  userReturn: EbUser = AuthenticationService.getConnectedUser();


  constructor() {
    this.emailNomPrenom = null;
    this.ebUserNum = null;
    this.email = null;
    this.ebUserPassword = null;
    this.ebEtablissementNum = null;
    this.withListAdresse = false;
    this.withListCostCenter = false;
    this.withListContacts = false;
    this.withAccessRights = false;
    this.withPassword = false;
    this.searchterm = null;
    this.pageNumber = 0;
    this.size = 10;
    this.roleBroker = false;
    this.roleTransporteur = false;
    this.roleControlTower = false;
    this.roleChargeur = false;
    this.status = null;
    this.demandeEnCours = true;
    this.admin = true;
    this.ecRoleNum = null;
    this.forInvite = null;
    this.ebDestinationCountryNum = null;
    this.ebCompagnieNum = null;
    this.ebCompagnieGuestNum = null;
    this.receivedRequest = false;
    this.contactable = false;
    this.contact = false;
    this.blackList = false;
    this.notBlackList = false;
    this.sentRequests = false;
    this.ebDemandeNum = null;
    this.module = null;
    this.ecCountryNum = null;
    this.userService = null;
    this.hsCode = null;
    this.dateDeb = null;
    this.dateFin = null;
    this.etablissementRequest = false;
    this.excludeConnectedUser = false;
    this.relationWIthEtablissement = false;
    this.user = null;
    this.ebCommandeNum = null;
    this.forChargeur = false;
    this.forControlTower = false;
    this.ignoreContact = false;

    this.listTransportRef = new Array<number>();
    this.listCustomerReference = new Array<number>();
    this.listDestinations = new Array<number>();
    this.listOrigins = new Array<number>();
    this.listCarrier = new Array<number>();
    this.listStatut = new Array<number>();
    this.listCostCenter = new Array<number>();

    this.listTransportRefPlugin = new Array<any>();
    this.listCustomerReferencePlugin = new Array<any>();
    this.listDestinationsPlugin = new Array<any>();
    this.listOriginsPlugin = new Array<any>();
    this.listCarrierPlugin = new Array<any>();
    this.listStatutPlugin = new Array<any>();
    this.listCostCenterPlugin = new Array<any>();

    this.datePickUpTo = null;
    this.datePickUpFrom = null;
    this.datePickUpToPlugin = null;
    this.datePickUpFromPlugin = null;

    this.dateCreationTo = null;
    this.dateCreationFrom = null;
    this.dateCreationToPlugin = null;
    this.dateCreationFromPlugin = null;

    this.dateCommandeFrom = null;
    this.dateCommandeFromPlugin = null;
    this.dateCommandeTo = null;
    this.dateCommandeToPlugin = null;
    this.listCommandeNum = null;
    this.onlyAddressForEtablissement = false;
    this.mawb = null;
    this.numAwbBol = null;
    this.dateDepartFrom = null;
    this.dateDepartTo = null;
    this.export = null;

    this.ecMotifNum = null;

    this.superAdmin = false;
  }

  constructorCopy(advancedOptions: SearchCriteria) {
    this.listCommandeNum = advancedOptions.listCommandeNum;
    this.listTransportRefPlugin = advancedOptions.listTransportRefPlugin;
    this.listCustomerReferencePlugin =
      advancedOptions.listCustomerReferencePlugin;
    this.listDestinationsPlugin = advancedOptions.listDestinationsPlugin;
    this.listOriginsPlugin = advancedOptions.listOrigins;
    this.listCarrierPlugin = advancedOptions.listCarrierPlugin;
    this.listStatutPlugin = advancedOptions.listStatutPlugin;
    this.listCostCenterPlugin = advancedOptions.listCostCenterPlugin;

    advancedOptions.listTransportRefPlugin.forEach((transportref, index) => {
      this.listTransportRef.push(transportref.ebDemandeNum);
    });

    advancedOptions.listCustomerReferencePlugin.forEach(
      (customerref, index) => {
        this.listCustomerReference.push(customerref.ebCommandeNum);
      }
    );

    advancedOptions.listDestinationsPlugin.forEach((dest, index) => {
      this.listDestinations.push(dest.ecCountryNum);
    });

    advancedOptions.listOriginsPlugin.forEach((origi, index) => {
      this.listOrigins.push(origi.ecCountryNum);
    });

    if (advancedOptions.listTransportRefPlugin) {
      advancedOptions.listTransportRefPlugin.forEach((transportref, index) => {
        this.listTransportRef.push(transportref.ebDemandeNum);
      });
    }
    if (advancedOptions.listCustomerReferencePlugin) {
      advancedOptions.listCustomerReferencePlugin.forEach(
        (customerref, index) => {
          this.listCustomerReference.push(customerref.ebCommandeNum);
        }
      );
    }
    if (advancedOptions.listDestinationsPlugin) {
      advancedOptions.listDestinationsPlugin.forEach((dest, index) => {
        this.listDestinations.push(dest.ecCountryNum);
      });
    }
    if (advancedOptions.listCarrierPlugin) {
      advancedOptions.listCarrierPlugin.forEach((carrier, index) => {
        this.listCarrier.push(carrier.ebUserNum);
      });
    }
    if (advancedOptions.listStatutPlugin) {
      advancedOptions.listStatutPlugin.forEach((statut, index) => {
        this.listStatut.push(statut.code);
      });
    }
    if (advancedOptions.listCostCenterPlugin) {
      advancedOptions.listCostCenterPlugin.forEach((cost, index) => {
        this.listCostCenter.push(cost.ebCostCenterNum);
      });
    }

    this.datePickUpToPlugin = advancedOptions.datePickUpToPlugin;
    this.datePickUpFromPlugin = advancedOptions.datePickUpFromPlugin;
    this.datePickUpTo = advancedOptions.datePickUpTo;
    this.datePickUpFrom = advancedOptions.datePickUpFrom;

    this.dateCreationToPlugin = advancedOptions.dateCreationToPlugin;
    this.dateCreationFromPlugin = advancedOptions.dateCreationFromPlugin;
    this.dateCreationTo = advancedOptions.dateCreationTo;
    this.dateCreationFrom = advancedOptions.dateCreationFrom;

    this.dateCommandeToPlugin = advancedOptions.dateCommandeToPlugin;
    this.dateCommandeFromPlugin = advancedOptions.dateCommandeFromPlugin;
    this.dateCreationTo = advancedOptions.dateCreationTo;
    this.dateCommandeFrom = advancedOptions.dateCommandeFrom;
    this.mawb = advancedOptions.mawb;
    this.numAwbBol = advancedOptions.numAwbBol;
    this.dateDepartFrom = advancedOptions.dateDepartFrom;
    this.dateDepartTo = advancedOptions.dateDepartTo;
    this.export = advancedOptions.export;

    this.ecMotifNum = advancedOptions.ecMotifNum;

    this.superAdmin = advancedOptions.superAdmin;
  }

  formatDates() {
    if (this.datePickUpToPlugin != null)
      this.datePickUpTo = Statique.formatDateFromDatePicker(
        this.datePickUpToPlugin
      );
    if (this.datePickUpFromPlugin != null)
      this.datePickUpFrom = Statique.formatDateFromDatePicker(
        this.datePickUpFromPlugin
      );
    if (this.dateCreationToPlugin != null)
      this.dateCreationTo = Statique.formatDateFromDatePicker(
        this.dateCreationToPlugin
      );
    if (this.dateCreationFromPlugin != null)
      this.dateCreationFrom = Statique.formatDateFromDatePicker(
        this.dateCreationFromPlugin
      );

    if (this.dateCommandeToPlugin != null)
      this.dateCommandeTo = Statique.formatDateFromDatePicker(
        this.dateCommandeToPlugin
      );
    if (this.dateCommandeFromPlugin != null)
      this.dateCommandeFrom = Statique.formatDateFromDatePicker(
        this.dateCommandeFromPlugin
      );
    return this;
  }

  setUser(user: EbUser) {
    if (user != null) {
      try {
        let newUser = new EbUser();
        newUser.constructorCopyLite(user);
        this.user = JSON.stringify(newUser);
      } catch (e) {}
    }
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/searchCriteria.ts